<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование баннера" : "Добавление баннера"'
  )
  v-card
    v-tabs(v-model='active' color='dark' slider-color='primary')
      v-tab Основное
      v-tab-item(:transition='false' :reverse-transition='false')
        v-container(grid-list-xl fluid)
          v-layout(wrap)
            v-flex(xs12 sm12)
              div(class="picker")
                s-publish-date-status(
                  :errors='errors'
                  :model='item'
                )
            v-flex(xs12 sm6)
              s-datetime-picker(
                :today='false'
                :validator='errors'
                v-model='item.start_time'
                label='Начало показа'
                name='start_time'
              )
            v-flex(xs12 sm6)
              s-datetime-picker(
                :today='false'
                :validator='errors'
                v-model='item.stop_time'
                label='Завершение показа'
                name='stop_time'
              )
            v-flex(xs12)
              s-region-picker(
                v-model='item.regions'
                multiple
                chips
              )
            v-flex(xs12)
              v-text-field(
                :error='errors.has("name")'
                :error-messages='errors.first("name")'
                v-model='item.name'
                label='Название банера'
              )
            v-flex(xs12)
              v-textarea(
                :error='errors.has("annotation")'
                :error-messages='errors.first("annotation")'
                v-model='item.annotation'
                label='Комментарий'
                counter
              )
          div(v-if='blocks.length > 0')
            v-layout(:style="{ 'margin-top': '24px' }")
              v-flex(xs12)
                h3(class="display-0") Блоки
              s-sort-button(@click='sorting.opened = true' class='mr-3')
            table(class='v-datatable v-table theme--light')
              thead
                tr
                  th(align='left') Название
                  th(align='right')
              tbody
                template(v-for='(block, index) in blocks')
                  tr(:key='block.id')
                    td(class='t-col')
                      div(v-if='block.name')
                        |{{ block.part }} {{ block.name }}
                      div(v-else)
                        v-img(:src='block.picture_url' :width='120')
                    td(class='t-col text-xs-right')
                      s-publish-status-toggle(
                        :value='block'
                        :resource="'banners/' + id + '/block'"
                        @success='updateItem'
                      )
        v-card-actions(class='large')
          v-spacer
          s-back-btn
          v-btn(
            @click='onSave'
            :loading='isLoading'
            color='primary'
            depressed
          ) Сохранить
      v-tab(v-if='id') Блоки
      v-tab-item(:transition='false' :reverse-transition='false')
        v-container(grid-list-xl fluid)
          div(class="add-block")
            v-btn(
              @click='addBlock'
              :style='{ margin: 0 }'
              depressed
            ) Добавить блок
          div(v-for='(block, index) in blocks' :key='block.id' class='banner-block')
            v-layout(wrap)
              v-flex(xs12)
                s-publish-date-status(
                  :errors='errors'
                  :model='block'
                )
              v-flex(xs6)
                v-select(
                  v-if='attributes'
                  :error='Boolean(vError(index, "part"))'
                  :error-messages='vError(index, "part")'
                  :items='attributes.part'
                  item-text='name'
                  item-value='id'
                  v-model='block.part'
                  label='Размер'
                )
              v-flex(xs6)
                v-select(
                  v-if='attributes'
                  :error='Boolean(vError(index, "type"))'
                  :error-messages='vError(index, "type")'
                  :items='attributes.type'
                  item-text='name'
                  item-value='id'
                  v-model='block.type'
                  label='Тип отображения'
                )
            v-layout(v-if='block.type==="image"' wrap)
              v-flex(xs12)
                s-image-upload(
                  :src='block.picture_url'
                  :error='Boolean(vError(index, "picture"))'
                  :error-messages='vError(index, "picture")'
                  v-model='block.picture'
                  label='Картинка'
                )
            v-layout(v-if='block.type=="timer"' wrap)
              v-flex(xs6)
                s-datetime-picker(
                  :today='false'
                  :validator='errors'
                  v-model='block.timer_till'
                  label='Отсчет таймера до'
                  name='timer_till'
                )
              v-flex(xs6)
                v-text-field(
                  :error='errors.has("timer_text")'
                  :error-messages='errors.first("timer_text")'
                  v-model='block.timer_text'
                  label='Текст на таймере'
                )
            v-layout(v-if='block.type!="image"' wrap)
              v-flex(xs6)
                v-textarea(
                  :error='Boolean(vError(index, "name"))'
                  :error-messages='vError(index, "name")'
                  v-model='block.name'
                  label='Заголовок'
                )
              v-flex(xs6)
                v-text-field(
                  :error='Boolean(vError(index, "sub_name"))'
                  :error-messages='vError(index, "sub_name")'
                  v-model='block.sub_name'
                  label='Подзаголовок'
                )
              v-flex(xs3)
                s-color-picker(
                    v-if='attributes'
                    :error='Boolean(vError(index, "color"))'
                    :error-messages='vError(index, "color")'
                    :items='attributes.color'
                    v-model='block.color'
                    label='Цвет заголовка'
                )
                
              v-flex(xs3)
                s-color-picker(
                  v-if='attributes'
                  :error='Boolean(vError(index, "bg_color"))'
                  :error-messages='vError(index, "bg_color")'
                  :items='attributes.bg_color'
                  v-model='block.bg_color'
                  label='Цвет фона'
              )
              v-flex(xs6)
                v-text-field(
                  :error='Boolean(vError(index, "link"))'
                  :error-messages='vError(index, "link")'
                  v-model='block.link'
                  label='Cсылка для перехода'
                )
              v-flex(xs6)
                v-text-field(
                  :error='Boolean(vError(index, "link_name"))'
                  :error-messages='vError(index, "link_name")'
                  v-model='block.link_name'
                  label='Текст ссылки для перехода'
                )
              v-flex(xs6)
                v-select(
                  v-if='attributes'
                  :error='Boolean(vError(index, "request_type"))'
                  :error-messages='vError(index, "request_type")'
                  :items='attributes.request_type'
                  :clearable='true'
                  item-text='name'
                  item-value='id'
                  v-model='block.request_type'
                  label='Вызвать форму по клику'
                )
            v-layout(class='block-actions')
              v-flex(xs12)
                v-btn(
                  @click='updateBlock(block, index)'
                  :loading='isLoading'
                  :style='{ margin: 0 }'
                  depressed
                ) Сохранить
                v-btn(
                  @click='removeBlock(block, index)'
                  :loading='isLoading'
                  :style='{ "margin-left": 24 }'
                  depressed
                  flat
                ) Удалить
  s-sorting-list(
    v-model='sorting'
    :collection='blocks'
    @sort-success='updateItem'
    @sort-request='sortBlocks'
  )
</template>

<script>
import http from '@/http'
import { mapActions, mapGetters } from 'vuex'

const getBlockModel = () => ({
  type: null,
  color: null,
  bg_color: null,
  name: null,
  sub_name: null,
  link: null,
  timer_till: null,
  timer_text: 'до окончания акции',
  link_name: 'Подробнее',
  picture: null,
  request_type: null,
  published: false,
  published_at: new Date().toString()
})

export default {
  props: ['id'],

  components: {},

  data: () => ({
    item: {},
    active: 0,
    attributes: {},
    blocks: [],
    bErrors: {},
    sorting: {
      opened: false,
      itemValue: 'id',
      itemText: 'name',
      renderFn(item) {
        if (item.name) return item.part + ` ` +item.name
        return item.part + ` ` +`<img src="${item.picture_url}" width="120"/>`
      }
    }
  }),

  async created() {
    if (!this.id) return
    this.updateItem()
  },

  methods: {
    async updateItem() {
      const response = await this.fetchSingle({ id: this.id })
      this.item = response.data
      this.initBlocks()
    },

    async onSave() {
      const data = this.item
      try {
        if (this.id) await this.update({ id: this.id, data })
        else await this.create({ data })
        this.$root.showSnack('Баннер сохранен')
        if(!this.id)
          this.$router.push({ name: 'Content.Banners.List' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    async fetchAttributes() {
      try {
        const res = await http.get('/banners/block/attributes')
        this.attributes = res.data
      } catch(error) {
        this.$root.showSnack('Ошибка загрузки атрибутов')
      }
    },

    async updateBlock(block, index) {
      // удалим ошибку
      this.bErrors[index] = null
      // удалим картинку
      if (block.type !== 'image') {
        block.picture = null
      }
      // upsert
      try {
        if (block.id) await http.patch(`/banners/${this.id}/block/${block.id}`, block)
        else await http.post(`/banners/${this.id}/block`, block)
        this.$root.showSnack('Блок обновлен')
        this.updateItem()
      } catch(error) {
        const vError = error.response.data.errors
        this.$set(this.bErrors, [index], vError)
        // сраное говно или руки
        this.blocks = [...this.blocks]
        this.$root.showSnack('Ошибка обновления блока')
      }
    },

    async removeBlock(block, index) {
      if (!await this.$confirm('Удалить блок?')) {
        return
      }

      if (!block.id) {
        this.blocks.splice(index, 1)
        return
      }

      try {
        await http.delete(`/banners/${this.id}/block/${block.id}`)
        this.blocks.splice(index, 1)
        this.updateItem()
      } catch(error) {
        this.$root.showSnack('Ошибка удаления блока')
      }
    },

    async sortBlocks(ids) {
      try {
        await http.post(`/banners/${this.id}/sort-ref`, { sort_ids: ids })
        this.updateItem()
      } catch(error) {
        this.$root.showSnack('Ошибка сортировки')
      }
    },

    addBlock() {
      const block = getBlockModel()
      // инициализация дефолтных значений
      const attrKeys = Object.keys(this.attributes)
      attrKeys.forEach(key => {
        if (block.hasOwnProperty(key)) {
          const target = this.attributes[key]
          const foundVal = target.find(v => v.default)
          // засетим если нашли дефолтное значение
          if (foundVal) {
            block[key] = foundVal.id
          }
        }
      })

      this.blocks = [block, ...this.blocks]
      this.bErrors = {}
    },

    initBlocks() {
      if (this.item.blocks) {
        this.blocks = JSON.parse(JSON.stringify(this.item.blocks))
        this.fetchAttributes()
      }
    },

    vError(index, key) {
      if (this.bErrors[index] && this.bErrors[index][key]) {
        return this.bErrors[index][key]
      }
    },

    ...mapActions('content/banners', ['fetchSingle', 'update', 'create'])
  },

  computed: {
    ...mapGetters('content/banners', ['isLoading'])
  }
}
</script>

<style scoped>
.small textarea {
  font-size: 12px;
}
.add-block {
  margin-bottom: 24px;
}
.hr {
  height: 1px;
  margin: 24px 0;
  background: #ccc;
}
.banner-block {
  padding-top: 15px;
  padding-bottom: 15px;
  border-top: 1px dashed dimgray;
  margin-bottom: 25px;
}
.block-actions {
  background-color: #27ae6024;
}
</style>
